import { FormEvent, Fragment, JSX } from "react";
import PillButton from "../pillButton/PillButton";
import React from "react";

export const Modal = ({
  isOpen,
  children,
  headerText,
  headerIcon = "✕",
  showSubmit,
  submitText,
  showOverflow = true,
  handleSubmit,
  modalNumber = 4,
  onToggleModal,
}: {
  isOpen: boolean;
  headerText: string;
  showSubmit?: boolean;
  submitText?: string;
  headerIcon?: string;
  modalNumber?: number;
  showOverflow?: boolean;
  children: JSX.Element | string;
  handleSubmit?: (e: FormEvent<HTMLFormElement>) => void;
  onToggleModal: () => void;
}) => {
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-[#0080FF] bg-opacity-30 flex justify-center items-center`}
      style={{ zIndex: modalNumber }}
    >
      {/* Modal Wrapper */}
      <div
        className={`bg-white flex flex-col rounded-lg w-[680px] max-md:w-[90%] max-h-[90vh] relative shadow-lg`}
      >
        {/* Close Button */}
        <div className="sticky bg-white top-0 z-10 flex justify-between items-start px-6 pt-6 pb-2 rounded-t-lg border-b">
          {/* Modal Header */}
          <h2 className="text-xl font-semibold text-blue-700">{headerText}</h2>
          <button
            onClick={onToggleModal}
            className=" text-gray-500 hover:text-gray-700"
          >
            {headerIcon}
          </button>
        </div>
        {!handleSubmit && (
          <div
            className={`px-6 pb-6 flex-1 min-h-0 ${
              showOverflow === true && "overflow-y-auto"
            }`}
          >
            {children}
          </div>
        )}
        {/* Modal Form */}
        {handleSubmit && (
          <Fragment>
            <form
              onSubmit={(e) => handleSubmit(e)}
              className={`px-6 pb-6 flex-1 min-h-0 ${
                showOverflow === true && "overflow-y-auto"
              }`}
            >
              {children}
              <div className="md:col-span-2 mt-4 flex justify-center">
                <button type="submit" disabled={!showSubmit}>
                  <PillButton
                    text={submitText || ""}
                    className={`${
                      !showSubmit &&
                      "!bg-gray-600 text !hover:bg-gray-600 cursor-not-allowed"
                    }`}
                  />
                </button>
              </div>
            </form>
          </Fragment>
        )}
      </div>
    </div>
  );
};
